import React from "react";
import { FiExternalLink, FiEdit, FiTrash2 } from "react-icons/fi";
import Modal from "../../common/modal/Modal";
import { cleanText, getCatalogDate, getCatalogMedia, getCatalogPrice, getWebsiteHref } from "./catalogUtils";

const MEDIA_STYLE = { width: 240, height: 160 };

const CatalogDetailsModal = ({ open, loading, catalog, canManage, onClose, onEdit, onDelete }) => {
  const media = getCatalogMedia(catalog);
  const category = cleanText(catalog?.type?.name);
  const price = getCatalogPrice(catalog);
  const description = cleanText(catalog?.description);
  const createdOn = getCatalogDate(catalog);
  const website = getWebsiteHref(catalog?.url);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={category || "Catalog details"}
      size="lg"
      footer={
        <>
          {canManage && catalog && (
            <>
              <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => onEdit(catalog)}>
                <FiEdit size={13} aria-hidden="true" /> Edit
              </button>
              <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => onDelete(catalog)}>
                <FiTrash2 size={13} aria-hidden="true" /> Delete
              </button>
            </>
          )}
          <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
            Close
          </button>
        </>
      }
    >
      {loading || !catalog ? (
        <div className="text-center py-4" role="status" aria-live="polite">
          <div className="spinner-border spinner-border-sm text-primary" aria-hidden="true" />
          <p className="text-muted small mt-2 mb-0">Loading details…</p>
        </div>
      ) : (
        <div>
          {media.length > 0 && (
            <div className="d-flex gap-2 overflow-auto pb-2 mb-3" tabIndex={0} aria-label="Catalog media">
              {media.map((item) =>
                item.isVideo ? (
                  <video key={item.url} src={item.url} controls className="rounded-3 flex-shrink-0" style={MEDIA_STYLE} />
                ) : (
                  <img
                    key={item.url}
                    src={item.url}
                    alt={category ? `${category} design` : "Catalog design"}
                    className="rounded-3 object-fit-cover shadow-sm flex-shrink-0"
                    style={MEDIA_STYLE}
                    loading="lazy"
                  />
                )
              )}
            </div>
          )}
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
            {category && <span className="badge bg-primary bg-opacity-10 text-primary fs-6">{category}</span>}
            <h3 className="fw-bold text-dark mb-0 fs-5">{price || "Price on request"}</h3>
          </div>
          {description && (
            <>
              <h4 className="fs-6 fw-bold text-dark mb-1">Description</h4>
              <p className="text-secondary small mb-3" style={{ whiteSpace: "pre-wrap" }}>
                {description}
              </p>
            </>
          )}
          {createdOn && <p className="text-muted small mb-3">Added {createdOn}</p>}
          {website && (
            <a href={website} target="_blank" rel="noreferrer noopener" className="btn btn-outline-primary btn-sm">
              <FiExternalLink size={14} aria-hidden="true" /> Visit project portfolio
            </a>
          )}
        </div>
      )}
    </Modal>
  );
};

export default CatalogDetailsModal;
